import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useSeo } from "../lib/seo";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  useSeo({
    title: "Shop Home Decor Online",
    description:
      "Browse the full Aethel Decor collection — wooden trays, ceramic bowls & platters, cotton bedsheets, cushion & sofa covers, table mats and runners. Free shipping, COD available.",
    path: "/shop",
  });
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "all";
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: { category, search: search || undefined } })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category, search]);

  const setCategory = (slug) => {
    if (slug === "all") params.delete("category");
    else params.set("category", slug);
    setParams(params);
  };

  const activeName =
    category === "all"
      ? "All Products"
      : cats.find((c) => c.slug === category)?.name || "Products";

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12" data-testid="shop-page">
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold">Collection</p>
        <h1 className="mt-3 text-4xl sm:text-5xl text-primary font-medium">{activeName}</h1>
      </div>

      <div className="flex flex-col lg:flex-row gap-10">
        {/* Sidebar */}
        <aside className="lg:w-56 shrink-0">
          <input
            type="text"
            placeholder="Search products…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-muted px-4 py-3 text-sm outline-none focus:ring-1 focus:ring-primary mb-6"
            data-testid="shop-search"
          />
          <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">Categories</p>
          <ul className="space-y-1">
            <li>
              <button
                onClick={() => setCategory("all")}
                className={`text-left w-full py-1.5 text-sm transition-colors ${
                  category === "all" ? "text-primary font-semibold" : "text-foreground/70 hover:text-primary"
                }`}
                data-testid="cat-all"
              >
                All Products
              </button>
            </li>
            {cats.map((c) => (
              <li key={c.slug}>
                <button
                  onClick={() => setCategory(c.slug)}
                  className={`text-left w-full py-1.5 text-sm transition-colors ${
                    category === c.slug ? "text-primary font-semibold" : "text-foreground/70 hover:text-primary"
                  }`}
                  data-testid={`cat-${c.slug}`}
                >
                  {c.name}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Grid */}
        <div className="flex-1">
          {loading ? (
            <div className="py-24 text-center text-muted-foreground">Loading…</div>
          ) : products.length === 0 ? (
            <div className="py-24 text-center text-muted-foreground" data-testid="shop-empty">
              No products found.
            </div>
          ) : (
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {products.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
